<style lang="stylus">
    .pcShareMenu
        position relative
        z-index 1
        margin-bottom 10px
        .pcShare-menubox-menu
            display flex
            list-style none
            --tLeft 0
            --tWidth 0
            &::after
                content ''
                position absolute
                height 100%
                width calc(var(--tWidth, 0) * 1px)
                left calc(var(--tLeft, 0) * 1px)
                border-bottom 2px solid var(--themeColor)
                transition left .2s linear, width .2s linear
            li
                position relative
                max-width 120px
                height 24px
                margin 5px 20px 5px 0
                color rgba(0, 0, 0, 0.6)
                font-size 14px
                text-align center
                line-height 24px
                cursor pointer
                transition background .2s linear
                p
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                &:hover,&.active
                    >p
                        background #fafafa
                        color var(--themeColor)
                .pcShare-menubox-tips
                    position absolute
                    left 0
                    top 35px
                    padding 5px 10px
                    background rgba(0,0,0,.6)
                    color #fff
                    z-index 1
                    font-size 12px
                    border-radius 3px
                    max-width 220px
                    cursor default
                    &::after
                        content ''
                        position absolute
                        width 0
                        height 0
                        left 20px
                        top -20px
                        border 10px solid rgba(0,0,0,.6)
                        border-top-color transparent
                        border-left-color transparent
                        border-right-color transparent
</style>

<template>
    <div class="pcShareMenu">
        <ul ref="pcShareMenu" class="pcShare-menubox-menu">
            <li :class="{ active: menuID == item.id }" v-for="item in menuList" :key="item.id" @click="clickMenu($event, item.id)">
                <p>{{ $t(item.label) }}</p>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class PCShare extends Vue {
        menuList: Array<object> = [
            {
                id: 0,
                label: "shares",
                type: "share",
            },
            {
                id: 1,
                label: "shareToMe",
                type: "shareToMe",
            },
        ];
        menuID: number = 0;
        menuIndex: number = 0;

        clickMenu(e, id) {
            let pDom = this.$refs.pcShareMenu as HTMLElement;
            console.log(e.target);
            pDom.style.setProperty("--tWidth", e.target.parentNode.clientWidth);
            pDom.style.setProperty("--tLeft", e.target.parentNode.offsetLeft);
            this.menuID = id;
            for (let i = 0; i < this.menuList.length; i++) {
                if (this.menuList[i]["id"] == id) {
                    this.menuIndex = i;
                    break;
                }
            }
            this.$bus.$emit("changePCShareView", this.menuList[this.menuIndex]["type"]);
        }
        toMenu(index) {
            let pDom = this.$refs.pcShareMenu as HTMLElement;
            let w = pDom.children[index].getBoundingClientRect()["width"];
            let l = pDom.children[index].getBoundingClientRect()["x"] - pDom.getBoundingClientRect()["x"];
            pDom.style.setProperty("--tLeft", "" + l);
            pDom.style.setProperty("--tWidth", "" + w);
            this.menuID = this.menuList[index]["id"];
            this.menuIndex = index;
        }

        mounted() {
            this.toMenu(0);
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "shareToMe": "分享给我",
    "shares": "我的分享"
  },
  "en": {
    "shareToMe": "Share with me",
    "shares": "Share"
  },
  "fr": {
    "shareToMe": "Partage avec moi",
    "shares": "Ma part"
  },
  "de": {
    "shareToMe": "Teile mit mir",
    "shares": "Mein Share"
  },
  "jp": {
    "shareToMe": "私との共有",
    "shares": "私の共有"
  },
  "es": {
    "shareToMe": "Comparte con",
    "shares": "Compartir"
  },
  "pt": {
    "shareToMe": "Compartilhe comigo",
    "shares": "Partilhar"
  },
  "it": {
    "shareToMe": "Condividi con me",
    "shares": "Condividi"
  },
  "tw": {
    "shareToMe": "分享給我",
    "shares": "我的分享"
  },
  "kr": {
    "shareToMe": "사용자에게 공유된 파일",
    "shares": "공유"
  },
  "id": {
    "shareToMe": "Bagikan dengan saya",
    "shares": "Bagikan"
  }
}
</i18n>
